import React, { ReactNode } from "react";
import IconClose from "../Icon/IconClose";

export type Props = {
  children?: ReactNode;
  classes?: string;
  theme?: string;
  full?: boolean;
  onClose?(): void;
};

const CardSticky: React.FC<Props> = ({
  children,
  classes = "",
  theme = "bg-neutral-80",
  full,
  onClose,
}) => {
  return (
    <div className="fixed bottom-0 left-0 right-0 flex justify-center ">
      <div
        className={
          "w-[480px] relative " +
          (classes ? classes : "") +
          (full && theme ? ` ${theme}` : "")
        }
      >
        {onClose && (
          <button type="button" className="ml-auto" onClick={onClose}>
            <IconClose size={20} />
          </button>
        )}
        {children}
      </div>
    </div>
  );
};

export default CardSticky;
